import React from "react";
import { STATUSES } from "../lib/constants";

const humanize = (id) =>
  (id || "")
    .toString()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : ""))
    .join(" ");

export default function StatusBadge({ status }) {
  const known = STATUSES.find((x) => x.id === status);
  const s = known || { label: humanize(status) || "—", color: "#52525B" };
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] uppercase tracking-[0.15em] font-bold border"
      style={{ color: s.color, borderColor: s.color, backgroundColor: `${s.color}10` }}
      data-testid={`status-badge-${status}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.color }} />
      {s.label}
    </span>
  );
}
